<template>
  <div class="analyse-charts-container">
    <div v-track:click="{event_id: 7}" class="header" style="margin: 0 20px;">
      <i class="el-icon-back" style="width: 20px; height: 25px; font-size: 24px; margin-top: 10px;cursor: pointer;" @click="handleReback" />
    </div>
    <div class="chart-content">
      <div id="analyse-pie-charts" class="left-chart chart-item" style="width: 25%; display: inline-block" />
      <div id="analyse-contrast" class="middle-chart chart-item" style="width: 40%; display: inline-block" />
      <div id="analyse-distribution" class="rigth-chart chart-item" style="width: 35%; display: inline-block" />
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import { analyseTracking } from '@/utils/tracking'
export default {
  name: 'AnalyseChart',
  props: {
    showChart: {
      type: Boolean,
      default: false
    },
    firstData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    meanData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      showAll: true,
      selectedType: '',
      pieOptions: {
        title: {
          text: '首日付费新老用户分布（点击筛选）',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a}<br />{b}:{c}({d}%)'
        },
        legend: {
          left: 'center',
          top: 30
        },
        color: ['#fc8452', '#73c0de', '#fac858', '#ee6666', '#5470c6', '#3ba272', '#9a60b4', '#ea7ccc'],
        series: [
          {
            name: '用户分布',
            type: 'pie',
            selectedMode: 'single',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              position: 'inner',
              formatter: (param) => {
                if (param.percent === 0) {
                  return ''
                } else {
                  return param.percent + '%'
                }
              }
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: '40',
            //     fontWeight: 'bold'
            //   }
            // },
            labelLine: {
              show: false
            }
          }
        ]
      },
      contrastOptions: {
        title: {
          text: '首日付费率',
          left: 'center'
        },
        legend: {
          data: ['参考均值', '当前数据'],
          top: 30
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%'
          }
        },
        yAxis: {
          type: 'category',
          data: ['1000元以上', '101-1000元', '11-100元', '0-10元']
        },
        grid: {
          left: '60',
          containLabel: true
        }
      },
      distributionOptions: {
        title: {
          text: '首日付费人数分布',
          left: 'center'
        },
        tooltip: {},
        legend: {
          top: 30
        },
        xAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}%'
          },
          max: 100
        },
        yAxis: {
          type: 'category',
          data: ['当前数据', '参考均值']
        },
        grid: {
          left: '60',
          containLabel: true
        }
      }
    }
  },
  created() {
    this.$nextTick(() => {
      this.initPieChart()
      this.initConstrastCharts()
      this.initDistributionCharts()
    })
  },
  methods: {
    initConstrastCharts(type = 'all') {
      const meanKey = type === 'all' ? 'mean_first_day_pay_money_level_rate' : type === 'new' ? 'mean_first_day_new_pay_money_level_rate' : 'mean_first_day_old_pay_money_level_rate'
      const firstKey = type === 'all' ? 'first_day_pay_money_level_rate' : type === 'new' ? 'first_day_new_pay_money_level_rate' : 'first_day_old_pay_money_level_rate'
      const chartDom = document.getElementById('analyse-contrast')
      const constrastChart = echarts.init(chartDom)
      const series = [
        { name: '参考均值',
          type: 'bar',
          label: {
            show: true,
            formatter: '{c}%',
            position: 'right'
          },
          itemStyle: {
            color: '#5470c6'
          },
          data: []
        }, {
          name: '当前数据',
          type: 'bar',
          label: {
            show: true,
            formatter: '{c}%',
            position: 'right'
          },
          itemStyle: {
            color: '#fac858'
          },
          data: []
        }
      ]
      for (let i = 0; i < 4; i++) {
        const meanKeyArr = meanKey.split('_')
        const firstKeyArr = firstKey.split('_')
        meanKeyArr[meanKeyArr.length - 2] += (4 - i)
        firstKeyArr[firstKeyArr.length - 2] += (4 - i)
        series[0].data.push((this.meanData[meanKeyArr.join('_')] * 100).toFixed(2))
        series[1].data.push((this.firstData[firstKeyArr.join('_')] * 100).toFixed(2))
      }
      this.contrastOptions.series = series
      const title = '首日付费率'
      this.contrastOptions.title.text = title + (type === 'new' ? '（新用户）' : type === 'old' ? '（老用户）' : '')
      constrastChart.setOption(this.contrastOptions)
    },
    initDistributionCharts(type = 'all') {
      const meanKey = type === 'all' ? 'mean_first_day_pay_money_level' : type === 'new' ? 'mean_first_day_new_pay_money_level' : 'mean_first_day_old_pay_money_level'
      const firstKey = type === 'all' ? 'first_day_pay_money_level' : type === 'new' ? 'first_day_new_pay_money_level' : 'first_day_old_pay_money_level'
      const chartDom = document.getElementById('analyse-distribution')
      const distributionChart = echarts.init(chartDom)
      const totalFirstData = Number(this.firstData[firstKey + '1']) + Number(this.firstData[firstKey + '2']) + Number(this.firstData[firstKey + '3']) + Number(this.firstData[firstKey + '4'])
      const totalMeanData = Number(this.meanData[meanKey + '1']) + Number(this.meanData[meanKey + '2']) + Number(this.meanData[meanKey + '3']) + Number(this.meanData[meanKey + '4'])
      const series = [{
        name: '0-10元',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: '{c}%'
        },
        emphasis: {
          focus: 'series'
        },
        tooltip: {
          formatter: (param) => {
            if (param.name === '参考均值') {
              return `${param.seriesName}<br />${param.name}:${this.meanData[meanKey + '1']}(${param.value}%)`
            } else {
              return `${param.seriesName}<br />${param.name}:${this.firstData[firstKey + '1']}(${param.value}%)`
            }
          }
        },
        itemStyle: {
          color: '#5470c6'
        },
        data: [(this.firstData[firstKey + '1'] / totalFirstData * 100).toFixed(2), (this.meanData[meanKey + '1'] / totalMeanData * 100).toFixed(2)]
      }, {
        name: '11-100元',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: '{c}%'
        },
        emphasis: {
          focus: 'series'
        },
        tooltip: {
          formatter: (param) => {
            if (param.name === '参考均值') {
              return `${param.seriesName}<br />${param.name}:${this.meanData[meanKey + '2']}(${param.value}%)`
            } else {
              return `${param.seriesName}<br />${param.name}:${this.firstData[firstKey + '2']}(${param.value}%)`
            }
          }
        },
        itemStyle: {
          color: '#fac858'
        },
        data: [(this.firstData[firstKey + '2'] / totalFirstData * 100).toFixed(2), (this.meanData[meanKey + '2'] / totalMeanData * 100).toFixed(2)]
      }, {
        name: '101-1000元',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: '{c}%'
        },
        emphasis: {
          focus: 'series'
        },
        tooltip: {
          formatter: (param) => {
            if (param.name === '参考均值') {
              return `${param.seriesName}<br />${param.name}:${this.meanData[meanKey + '3']}(${param.value}%)`
            } else {
              return `${param.seriesName}<br />${param.name}:${this.firstData[firstKey + '3']}(${param.value}%)`
            }
          }
        },
        itemStyle: {
          color: '#ee6666'
        },
        data: [(this.firstData[firstKey + '3'] / totalFirstData * 100).toFixed(2), (this.meanData[meanKey + '3'] / totalMeanData * 100).toFixed(2)]
      }, {
        name: '1000元以上',
        type: 'bar',
        stack: 'total',
        label: {
          show: true,
          formatter: '{c}%'
        },
        emphasis: {
          focus: 'series'
        },
        tooltip: {
          formatter: (param) => {
            if (param.name === '参考均值') {
              return `${param.seriesName}<br />${param.name}:${this.meanData[meanKey + '4']}(${param.value}%)`
            } else {
              return `${param.seriesName}<br />${param.name}:${this.firstData[firstKey + '4']}(${param.value}%)`
            }
          }
        },
        itemStyle: {
          color: '#73c0de'
        },
        data: [(this.firstData[firstKey + '4'] / totalFirstData * 100).toFixed(2), (this.meanData[meanKey + '4'] / totalMeanData * 100).toFixed(2)]
      }]
      const title = '首日付费人数分布'
      this.distributionOptions.title.text = title + (type === 'new' ? '（新用户）' : type === 'old' ? '（老用户）' : '')
      this.distributionOptions.series = series
      distributionChart.clear()
      distributionChart.setOption(this.distributionOptions)
      series.forEach(item => {
        if (item.data[0] === '0.00' && item.data[1] === '0.00') {
          distributionChart.dispatchAction({
            type: 'legendUnSelect',
            name: item.name
          })
        }
      })
    },
    initPieChart() {
      this.showAll = true
      const chartDom = document.getElementById('analyse-pie-charts')
      const pieChart = echarts.init(chartDom)
      const data = [
        { value: this.firstData.first_day_new_pay_count, name: '新用户' },
        { value: this.firstData.first_day_old_pay_count, name: '老用户' }
      ]
      this.pieOptions.series[0].data = data
      pieChart.on('click', (param) => {
        this.showAll = this.selectedType === param.name ? !this.showAll : false
        analyseTracking(8)
        if (this.showAll) {
          this.initDistributionCharts()
          this.initConstrastCharts()
        } else {
          this.selectedType = param.name
          if (param.name === '老用户') {
            this.initConstrastCharts('old')
            this.initDistributionCharts('old')
          } else if (param.name === '新用户') {
            this.initConstrastCharts('new')
            this.initDistributionCharts('new')
          }
        }
      })
      pieChart.clear()
      pieChart.setOption(this.pieOptions)
    },
    handleReback() {
      this.$emit('update:showChart', false)
      // analyseTracking(7)
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-content{
  display: flex;
  justify-content: space-around;
  margin-top: 15px;
  .chart-item{
    height: 380px;
    width: 38%;
  }
}
</style>
